var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        attrs: { id: "three_popups" },
        on: {
          click: function($event) {
            return _vm.$store.commit("newMessage")
          }
        }
      },
      [
        _c("div", { staticClass: "wrapper" }, [
          _c("div", { staticClass: "popup_blocks" }, [
            _c(
              "div",
              {
                staticClass: "popup_block",
                class: _vm.settings[_vm.type].class
              },
              [
                _c("div", {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      return _vm.$store.commit("newMessage")
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "popup_icon" }, [
                  _c("img", { attrs: { src: _vm.settings[_vm.type].icon } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "name_popup" }, [
                  _vm._v(_vm._s(_vm.messageTitle))
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.message))])
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26ad09a1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ad09a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/messages/alert-message.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-26ad09a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/messages/alert-message.vue
// module chunks = 0